import 'angular';

import 'angular-block-ui/dist/angular-block-ui.css';

import 'angular-block-ui';
import 'angular-sanitize';
import 'angular-translate';
import 'angular-translate-loader-static-files';

import '@uirouter/angularjs';
import '@uirouter/angular-hybrid';
import 'angular-ui-bootstrap';

import 'ua-device-detector';
import 're-tree';
import 'ng-device-detector';

import './controls/core.controls.module.ajs';
import './filters/core.filters.module.ajs';
import './directives/date-picker/date-picker.module.ajs';
import './directives/hotkey/hotkey.module.ajs';
import './services/services.module.ajs';

import { COUNTRIES }                      from '../shared/constants/countries.constant';
import { KEYCODES }                       from './constants/core.keycodes.constant.ajs';

import { CoreBlockUIConfig }              from './core.block-ui.config.ajs';
import { CoreRun }                        from './core.run.ajs';
import { CoreQConfig }                    from './core.q.config.ajs';
import { CoreRouterConfig }               from './core.router.config.ajs';
import { CoreTranslateConfig }            from './core.translate-config.ajs';
import { CoreUibConfig }                  from './core.uib.config.ajs';

import { CoreLiteCtrl }                   from './core';

import { BoxTogglerDirective }            from './directives/box-toggler.directive.ajs';
import { CoreChosenDirective }            from './directives/core.chosen.directive';
import { CoreDateDirective }              from './directives/core.date.directive';
import { CoreDropdownChosenDirective }    from './directives/core.dropdown-chosen.directive';
import { CoreEditableCellDirective }      from './directives/core.editableCell.directive';
import { CoreFlipModalDirective }         from './directives/core.flip-modal.directive';
import { CoreIntegrationFormDirective }   from './directives/core.integration-form.directive';
import { CoreReportDateDirective }        from './directives/core.report-date.directive';
import { CoreShortDateDirective }         from './directives/core.short-date.directive';
import { CoreValidSubmitDirective }       from './directives/core.valid-submit.directive';
import { GiveFocusDesktopDirective }      from './directives/core.give-focus-desktop.directive.ajs';
import { GiveFocusDirective }             from './directives/core.give-focus.directive.ajs';
import { NgMatchDirective }               from './directives/core.ng-match.directive.ajs';
import { PhoneValidatorDirective }        from './directives/core.phone-validator.directive.ajs';
import { PostcodeValidatorDirective }     from './directives/core.postcode-validator.directive.ajs';
import { SectionToggleDirective }         from './directives/section-toggle.directive.ajs';
import { TypeaheadEditableCellDirective } from './directives/typeahead.editable-cell.directive.ajs';
import { UniquenessValidatorDirective }   from './directives/core.uniqueness-validator.ajs';

angular.module('app-lite.core', [
  'blockUI',
  'ng.deviceDetector',
  'ngSanitize',
  'pascalprecht.translate',
  'ui.bootstrap',
  'ui.router',
  'ui.router.upgrade',

  'app-lite.core.controls',
  'app-lite.core.filters',
  'app-lite.core.date-picker',
  'app-lite.core.hotkey',
  'app-lite.core.services'
]).config(CoreBlockUIConfig)
  .config(CoreQConfig)
  .config(CoreRouterConfig)
  .config(CoreTranslateConfig)
  .config(CoreUibConfig)
  .constant('COUNTRIES', COUNTRIES)
  .constant('KEYCODES', KEYCODES)
  .controller('CoreLiteCtrl', CoreLiteCtrl)
  .directive('boxToggler', BoxTogglerDirective)
  .directive('chosen', CoreDropdownChosenDirective)
  .directive('date', CoreDateDirective)
  .directive('editableCell', CoreEditableCellDirective)
  .directive('flipModal', CoreFlipModalDirective)
  .directive('giveFocus', GiveFocusDirective)
  .directive('giveFocusDesktop', GiveFocusDesktopDirective)
  .directive('integrationForm', CoreIntegrationFormDirective)
  .directive('mdsChosen', CoreChosenDirective)
  .directive('ngMatch', NgMatchDirective)
  .directive('reportDate', CoreReportDateDirective)
  .directive('sectionToggle', SectionToggleDirective)
  .directive('shortDate', CoreShortDateDirective)
  .directive('typeaheadEditableCell', TypeaheadEditableCellDirective)
  .directive('validSubmit', CoreValidSubmitDirective)
  .directive('worPhoneValidator', PhoneValidatorDirective)
  .directive('worPostcodeValidator', PostcodeValidatorDirective)
  .directive('worUniquenessValidator', UniquenessValidatorDirective)
  .run(CoreRun);
